var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, HStack, Popover, Pressable, ScrollView, Text, VStack, } from "native-base";
import { useEffect, useState } from "react";
import { isWeb } from "@madmedical/utils";
import Tag from "../../atoms/Tag";
const MultiSelect = (_a) => {
    var { list, onChange, values = [], isRequired = false, isInvalid = false, error, hint, label, size = "sm", maxItems } = _a, rest = __rest(_a, ["list", "onChange", "values", "isRequired", "isInvalid", "error", "hint", "label", "size", "maxItems"]);
    const [selected, setSelected] = useState(values);
    const [isOpen, setIsOpen] = useState(false);
    const disableSelect = maxItems && selected.length >= maxItems ? true : false;
    useEffect(() => {
        onChange(selected);
    }, [selected, onChange]);
    const getHeight = () => {
        switch (size) {
            case "sm":
                return "8";
            case "md":
                return "11";
        }
    };
    const handleSelectPress = (key) => () => {
        if (disableSelect) {
            return;
        }
        setSelected((ps) => [...ps, key]);
        if (!isWeb) {
            setIsOpen(false);
        }
    };
    const handleRemovePress = (key) => () => {
        setSelected((previous) => previous.filter((s) => s !== key));
    };
    return (_jsxs(FormControl, Object.assign({ flex: 1, isInvalid: isInvalid, isRequired: isRequired }, { children: [label && (_jsx(FormControl.Label, Object.assign({ testID: "base-form-control-label", fontWeight: "medium" }, { children: label }))), _jsx(Popover, Object.assign({ useRNModal: true, placement: "top left", trigger: (triggerProps) => (_jsx(Pressable, Object.assign({}, triggerProps, { _focus: {
                        borderColor: disableSelect
                            ? "gray.200"
                            : "primary.500",
                    }, _hover: {
                        borderColor: disableSelect
                            ? "gray.200"
                            : "primary.500",
                    }, borderWidth: "1", borderColor: "gray.200", minHeight: getHeight(), px: "3", py: "2", pt: 1, width: "64", borderRadius: "md", bgColor: "white", alignItems: "center" }, rest, { onPress: () => disableSelect || isOpen
                        ? undefined
                        : setIsOpen(true) }, (disableSelect || isOpen
                    ? {
                        onPress: (e) => {
                            e.preventDefault();
                        },
                    }
                    : () => setIsOpen(!isOpen)), { children: _jsx(HStack, Object.assign({ width: "full", zIndex: 1 }, { children: _jsx(HStack, Object.assign({ flex: "1", flexWrap: "wrap", space: "1" }, { children: list
                                .filter(({ key }) => selected.includes(key))
                                .map(({ key, text }) => (_jsx(Tag, Object.assign({ hasClose: true, onPress: handleRemovePress(key), mt: 1 }, { children: _jsx(Text, { children: text }) }), key))) })) })) }))), onClose: () => setIsOpen(false), isOpen: isOpen }, { children: _jsx(Popover.Content, Object.assign({ zIndex: 50, background: "white", borderWidth: "0", shadow: "2", maxHeight: "56", overflowY: "auto", p: "0.5", flex: 1, width: 64, display: disableSelect ? "none" : "flex" }, { children: _jsx(ScrollView, { children: _jsx(VStack, { children: list
                                .filter(({ key }) => !selected.includes(key))
                                .map(({ key, text }) => (_jsx(Pressable, Object.assign({ onPress: handleSelectPress(key), _hover: {
                                    backgroundColor: "blueGray.50",
                                } }, { children: _jsx(Box, Object.assign({ px: "6", py: "2" }, { children: _jsx(Text, { children: text }) })) }), key))) }) }) })) })), hint && !error && (_jsx(Text, Object.assign({ mt: 1, fontSize: "sm", color: "gray.600" }, { children: hint }))), error && (_jsx(FormControl.ErrorMessage, Object.assign({ mt: 1, _text: { fontSize: "sm" } }, { children: error })))] })));
};
export default MultiSelect;
